// export const API_KEY = "AIzaSyAf9ooFmZQhuGcVgCypvMSwOamdteS9T_s";
export const API_KEY =
  process.env.VUE_APP_MODE === "staging"
    ? "AIzaSyDQap2UrnJs6hcTZIf87WHnBynrYHd_P-8"
    : process.env.VUE_APP_MODE === "development"
      ? "AIzaSyA6wi4sQTAD0cIlHTjEeCIjGZ8ijfDFPw8"
      : process.env.VUE_APP_MODE === "production"
        ? "AIzaSyBPMUIa05s8dilpdEFTV2GhGoKLQE66oPo"
        : "AIzaSyA6wi4sQTAD0cIlHTjEeCIjGZ8ijfDFPw8";

let initialized = !!window.google;

export default function initGMaps() {
  return new Promise((resolve, reject) => {
    if (initialized) return resolve(window.google);
    initialized = true;
    (<any>window).initMap = () => {
      resolve(window.google);
    };
    let targetLang = window.navigator.language;
    if (targetLang === "zh") targetLang = "zh-TW";
    else if (targetLang === "zh-tw") targetLang = "zh-TW";
    else if (targetLang === "zh-cn") targetLang = "zh-CN";

    const script = document.createElement("script");
    script.async = true;
    script.defer = true;
    script.src = `//maps.googleapis.com/maps/api/js?v=3.51&key=${API_KEY}&callback=initMap&libraries=geometry&language=${targetLang}`;
    script.onerror = reject;

    const head = document.querySelector("head");
    if (head === null) return reject();
    head.appendChild(script);
  });
}
